export default "/images/sendbat-hover.svg?67ec64fe801d896082962e4960e5c117";